module.exports = __webpack_public_path__ + "img/stunned.033fe65a.svg";